import { Injectable } from '@angular/core';
import { NgToastService } from 'ng-angular-popup';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import * as _ from 'lodash'
@Injectable({
  providedIn: 'root'
})
export class ToastService {
  messageSubject: any = new Subject<any>();
  private messages: any = []

  constructor(private toast: NgToastService, private toastr: ToastrService, private sanitizer: DomSanitizer) {
  }

  showPopup(msgType: string, msgHeader: string, msgDetail: any, duration?: number) {
    if (!duration) {
      duration = 3000
    }
    msgDetail = this.sanitizer.bypassSecurityTrustHtml(msgDetail);
    const index = _.findIndex(this.messages, { message: msgDetail });
    if (index < 0) {
      msgType = msgType.toUpperCase()
      // let audio: HTMLAudioElement = new Audio('../assets/audio/messagebox.mp3');
      // audio.play();
      
      let messageType = 'info';
      switch (msgType) {
        case 'WARN':
          // this.toast.warning({ detail: msgHeader, summary: msgDetail, duration: duration });
          messageType = 'warning'
          break;
        case 'SUCCESS':
          // this.toast.success({ detail: msgHeader, summary: msgDetail, duration: duration });
          messageType = 'success'
          break;
        case 'ERROR':
          // this.toast.error({ detail: msgHeader, summary: msgDetail, duration: duration });
          messageType = 'error'
          break;
        case 'INFO':
          // this.toast.info({ detail: msgHeader, summary: msgDetail, duration: duration });
          messageType = 'info'
          break;
      }
      this.messages.push({
        id: this.generateGuid(),
        header: msgHeader,
        type: messageType,
        message: msgDetail,
        duration: duration
      })
      // console.log("service this.messages", this.messages)
      this.messageSubject.next(this.messages)
    }

  }
  private showToastNotification(msgType: string, msgHeader: string, msgDetail: string, duration: number) {
    msgType = msgType.toUpperCase();
    switch (msgType) {
      case 'WARN':
        this.toastr.warning(msgHeader, msgDetail, { timeOut: duration });
        break;
      case 'SUCCESS':
        this.toastr.success(msgHeader, msgDetail, { timeOut: duration });
        break;
      case 'ERROR':
        this.toastr.error(msgHeader, msgDetail, { timeOut: duration });
        break;
      case 'INFO':
        this.toastr.info(msgHeader, msgDetail, { timeOut: duration });
        break;
    }
  }

  async showToast(msgType: string, msgHeader: string, msgDetail: string, duration?: number) {
    if (!duration) {
      duration = 3000;
    }
    
    try {
      const audio = new Audio('assets/audio/messagebox.mp3');
      await audio.play();
    } catch (error) {
      console.warn('Audio playback failed:', error);
    }
    
    this.showToastNotification(msgType, msgHeader, msgDetail, duration);
  }
  removeMessage(message: any) {
    this.messages = _.filter(this.messages, (msg: any) => {
      return msg.id != message.id
    })
  }
  generateGuid() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }
}
